module.exports = __webpack_public_path__ + "img/720.7cdba2ae.svg";